<template>
  <!-- Content -->
  <div class="content-wrapper">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12 col-xl-8 mb-4 mb-xl-0">
            <h3 class="font-weight-bold">Dashbord</h3>
          </div>
        </div>
      </div>
    </div>
     <div v-if="searching" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>
    <!--userInfo.user.role 1-->
    <div v-if="user.role > 1 && user.role < 4">
    <div class="mt-3"></div>
    <h5>Revenue Summary</h5>
    <div class="row">
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-tale">
          <div class="card-body">

            <p class="fs-25 mt-3"><PriceFormat :Price="dataz.transit"/></p>
            <p>On Transit Packages</p>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-tale">
          <div class="card-body">

            <p class="fs-25 mt-3"><PriceFormat :Price="dataz.revDay"/>/=</p>
            <p>To Day's Revenue</p>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-dark-blue">
          <div class="card-body">
            <p class="fs-25 mt-3"><PriceFormat :Price="dataz.rev7"/></p>
            <p>Last 7 Day's Revenue</p>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-dark-blue">
          <div class="card-body">
            <p class="fs-25 mt-3"><PriceFormat :Price="dataz.rev30"/></p>
            <p>Last 30 Day's Revenue</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3"></div>
    <h5>Messaging Summary</h5>
    <div class="row">
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-glau">
          <div class="card-body d-flex justify-content-between">
            <p>Last 7Day</p>
            <p class="fs-25"><PriceFormat :Price="sms_data.day7"/></p>

          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-glau">
          <div class="card-body d-flex justify-content-between">
            <p>Last 30Day</p>
            <p class="fs-25"><PriceFormat :Price=" sms_data.day30"/></p>

          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-glau">
          <div class="card-body d-flex justify-content-between">
            <p>Life Time</p>
            <p class="fs-25"><PriceFormat :Price="sms_data.sms_lifetime"/></p>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-glau">
          <div class="card-body d-flex justify-content-between">
            <p>SMS Balance</p>
            <p class="fs-25"><PriceFormat :Price="sms_data.sms_balance"/></p>

          </div>
        </div>
      </div>
    </div>
  </div>

    <h5>Branch Based Information</h5>
    <div class="row mt-3">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card tale-bg">
          <div class="card-people mt-auto">
            <img  :src="$store.state.img_url + user.branch_image" alt="people">
            <div class="weather-info">
              <div class="d-flex">
                <div class="ms-2">
                  <h3 class="location font-weight-normal">{{ user.branch_name }}</h3>
                  <h4 class="font-weight-normal">{{ user.branch_region }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin transparent">
        <div class="row">
          <div class="col-6 col-md-6 mb-4 stretch-card transparent">
            <div class="card card-tale">
              <div class="card-body center-items">
                <p class="mb-4">Incoming Packages</p>
                <p class="fs-30 mb-2">{{ dataz.incoming }}</p>
                <p></p>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-6 mb-4 stretch-card transparent">
            <div class="card card-dark-blue">
              <div class="card-body">
                <p class="mb-4">Outgoing Packages</p>
                <p class="fs-30 mb-2">{{ dataz.outgoing }}</p>
                <p></p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
            <div class="card card-light-blue">
              <div class="card-body">
                <p class="mb-4">Received Packages</p>
                <p class="fs-30 mb-2">{{ dataz.received }}</p>
                <p>Last 30 days</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-lg-0 stretch-card transparent">
            <div class="card card-light-danger">
              <div class="card-body">
                <p class="mb-4">Sent Packages</p>
                <p class="fs-30 mb-2"><PriceFormat :Price="dataz.sent"/></p>
                <p>Last 30 days</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
  components: {
    PriceFormat,
    PhoneFormat,
    DateFormat,

  },
  data() {
    return {
      searching: false,
      errors: "",
      sms_data: {},
      dataz: {},
      dashboardTimer: null,
      user: this.$attrs.user
    };
  },
  methods: {

    async dashbordDatas() {

      //this.searching = true

      var response = await axios
        .get(this.$store.state.api_url + "/web/dashbord-data")
        .catch((errors) => {
          //this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      //console.log(response.data)
      if (response.data.success) {
 //this.searching = false
        this.dataz = response.data.dataz;
        this.sms_data = response.data.sms_data;

      } else {
         //this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
    startDashboardTimer() {
      if (this.dashboardTimer) return;

      this.dashboardTimer = setInterval(() => {
        if (!document.hidden) {
          this.dashbordDatas();
        }
      }, 60000); // 10 seconds
    },

    stopDashboardTimer() {
      if (this.dashboardTimer) {
        clearInterval(this.dashboardTimer);
        this.dashboardTimer = null;
      }
    },

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopDashboardTimer();
      } else {
        // Refresh immediately when user returns
        this.dashbordDatas();
        this.startDashboardTimer();
      }
    }

  },
  created() {
    this.$store.state.page_name = "Dashbord"
    //this.dashbordDatas()
  },
    mounted() {
  //$('#dashbord').attr('class', 'nav-item active');
   // Load immediately
    this.dashbordDatas();
    // Start timer
    this.startDashboardTimer();

    // Listen for tab visibility changes
    document.addEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
    beforeUnmount() {
    this.stopDashboardTimer();

    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }
};
</script>
